export class EvaluationType {
    public static values = [
        //"Maltreatment Investigation",
        "Audit",
        "CHOW",
        "Common Project Activities",
        "Complaints",
        //"Compliance Investigation",
        "Engineering",
        "Initial Inspection",
        //"Maltreatment Investigation",
        "Scheduled Inspection"
    ];


    public static valuesFormB = [
        "CHOW",
        "Engineering",
        "Initial Inspection",
        "Scheduled Inspection"
    ];
}